import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type2LinkTable } from "./type2Link.table";

@Component({
  selector: "spec-app-type2-link-list-window",
  templateUrl: "./type2Link.list.html",
  styleUrls: ["./type2Link.list.scss"]
})
export class Type2LinkListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type2LinkTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type2LinkPage",
      this.tab.system,
      (object) => `Type2Link at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type2LinkList reload");
    super.reload();
    this.table.refreshList();
  }
}
